import React, { useContext } from "react";
import {
  AppContext,
  ProductsContext,
} from "../../../utils/stateHandlers/contexts";
import { Mobile, Default } from "../../../utils/deviceHelpers";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";

export default function DetailTable(props) {
  const { authToken } = useContext(AppContext);
  const { productState } = useContext(ProductsContext);
  const { priceLoaded, productDetails } = productState;
  return (
    <>
      <Mobile>
        <Typography variant="h2" sx={{ marginTop: "2rem" }}>
          Details
        </Typography>
        <Table size="small">
          {authToken && (
            <TableBody>
              {priceLoaded ? (
                <>
                  {productDetails &&
                    productDetails.map((data) => (
                      <TableRow key={data.label}>
                        {Object.values(data).map((detailData) => (
                          <TableCell key={detailData}>
                            <Typography>{detailData}</Typography>
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                </>
              ) : (
                <>
                  <TableRow>
                    <TableCell>
                      <Skeleton
                        variant="text"
                        width="10rem"
                        className="float-right"
                      />
                    </TableCell>
                    <TableCell>
                      <Skeleton
                        variant="text"
                        width="10rem"
                        className="float-right"
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Skeleton
                        variant="text"
                        width="10rem"
                        className="float-right"
                      />
                    </TableCell>
                    <TableCell>
                      <Skeleton
                        variant="text"
                        width="10rem"
                        className="float-right"
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Skeleton
                        variant="text"
                        width="10rem"
                        className="float-right"
                      />
                    </TableCell>
                    <TableCell>
                      <Skeleton
                        variant="text"
                        width="10rem"
                        className="float-right"
                      />
                    </TableCell>
                  </TableRow>
                </>
              )}
            </TableBody>
          )}
        </Table>
      </Mobile>
      <Default>
        <Typography variant="h2" sx={{ width: "92.5%", marginTop: "2rem" }}>
          Details
        </Typography>

        {authToken ? (
          <Table size="small" sx={{ width: "92.5%" }}>
            <TableBody>
              {priceLoaded ? (
                <>
                  {productDetails &&
                    productDetails.map((data) => (
                      <TableRow key={`${data.label}${data.value}`}>
                        <TableCell>
                          <Typography>{data.label}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography>{data.value}</Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                </>
              ) : (
                <>
                  <TableRow>
                    <TableCell>
                      <Skeleton
                        variant="text"
                        width="10rem"
                        className="float-right"
                      />
                    </TableCell>
                    <TableCell>
                      <Skeleton
                        variant="text"
                        width="10rem"
                        className="float-right"
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Skeleton
                        variant="text"
                        width="10rem"
                        className="float-right"
                      />
                    </TableCell>
                    <TableCell>
                      <Skeleton
                        variant="text"
                        width="10rem"
                        className="float-right"
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <Skeleton
                        variant="text"
                        width="10rem"
                        className="float-right"
                      />
                    </TableCell>
                    <TableCell>
                      <Skeleton
                        variant="text"
                        width="10rem"
                        className="float-right"
                      />
                    </TableCell>
                  </TableRow>
                </>
              )}
            </TableBody>
          </Table>
        ) : (
          <Typography sx={{ margin: "1rem" }}>
            To see the details of a specific product, click the "Login For
            Pricing" button at the top right of the screen.
          </Typography>
        )}
      </Default>
    </>
  );
}
